import { NAME } from './constants';
import { router } from './router';

export const ServiceDueDetails = {
	name: NAME,
	router,
};
